<template>
    <v-row no-gutters class="pb-2">
        <v-col cols="4" class="px-2 grey" v-if="updateAction">
            <v-menu v-model="dat1menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="actie_datum" label="Action date" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="actie_datum_2" :first-day-of-week="1" @input="actie_datum = $moment(actie_datum_2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
        </v-col>
        <v-col cols="8" class="px-2 grey" v-if="updateAction">
            <v-text-field v-model="actie_opm" label="Remark"></v-text-field>
        </v-col>
        <v-col cols="4" v-if="!updateAction">
            <v-text-field v-model="actie_datum" label="Action date" readonly></v-text-field> 
        </v-col>
        <v-col cols="8" class="pl-2" v-if="!updateAction">
            <v-text-field v-model="actie_opm" label="Action remark" readonly></v-text-field>
        </v-col>
        <v-col cols="8">
            <!-- <span v-if="updateAction">Changes will be done when you press "Save"</span> -->
            <v-btn class="mr-2" color="primary" x-small @click="actionVerify" v-if="actie_opm === 'Onboarding - please check the owner verification'">Goto verify</v-btn>
        </v-col>
        <v-col cols="4">
            <v-btn class="ml-16" color="primary" x-small @click="actionEdit" v-if="!updateAction">Edit action</v-btn>
            <v-btn class="mr-2" color="error"   x-small @click="actionClear" v-if="updateAction">Clear</v-btn>
            <v-btn class="mr-2" color="primary" x-small @click="actionCancel" v-if="updateAction">Cancel</v-btn>
            <v-btn class="mr-2" color="primary" x-small @click="actionSave" :disabled="actie_datum>''&&actie_opm===''" v-if="updateAction">Save</v-btn>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        components: {
        },
        props: {
            huis_encrid: {
                type: String,
                required: true
            },
            huis_actie_datum: {
                type: String,
                required: true
            },
            huis_actie_opm: {
                type: String,
                required: true
            },
            huis_code: {
                type: String,
                required: false,
                default: ""
            },
            inital_state: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        data() { 
            return {
                updateAction: false,
                dat1menu: false,
                actie_datum_2_org: "",
                actie_datum_org: "",
                actie_opm_org: "",

                actie_datum: "",
                actie_datum_2: "",
                actie_opm: ""
            }
        },
        mounted() {
            if (this.huis_encrid > "") {
                this.actie_datum_2 = this.huis_actie_datum;
                this.actie_datum = this.makeDate(this.actie_datum_2);
                this.actie_opm = this.huis_actie_opm;
                this.updateAction = this.inital_state;
            }
        },
        methods: {
            makeDate(isoDate) {
                if (!isoDate) return "";
                return isoDate.split("-").reverse().join("-");
            },
            actionEdit() {
                this.actie_datum_2_org = this.actie_datum_2;
                this.actie_datum_org = this.actie_datum;
                this.actie_opm_org = this.actie_opm;
                this.updateAction = true; 
            },
            actionCancel() {
                this.actie_datum_2 = this.actie_datum_2_org;
                this.actie_datum = this.actie_datum_org;
                this.actie_opm = this.actie_opm_org;
                this.updateAction = false; 
            },
            actionClear() {
                this.actie_datum_2 = "";
                this.actie_datum = "";
                this.actie_opm = ""; 
            },
            actionVerify() {
                let route = this.$router.resolve({ path: "/wzvz/wzvz_cs_overview/Agent/" + this.huis_code });
                window.open(route.href, "_blank");
            },
            actionSave() {
                this.$axios.post("ares/json/ares/huis/saveHuisAction.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHuisAction"
                    },
                    saveHuisAction: {
                        huis_encrid: this.huis_encrid,
                        actie_datum: this.actie_datum_2,
                        actie_opm: this.actie_opm
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveHuisAction.text,
                            color: res.data.saveHuisAction.color
                        });
                        this.$emit("updateData", this.actie_datum_2, this.actie_opm);
                        this.updateAction = false; 
                    }
                });
            },
        }
    }
</script>
